import { useFormik } from "formik";
import * as Yup from "yup";
import { validateCPF } from "../../../utils/DocumentUtils";
import ModalInfo from "../../../components/lib/modalInfo";
import { RiErrorWarningLine } from "react-icons/ri";

const ParentRegisterForm = ({ onSubmit, onDirty = () => { } }) => {
    const formik = useFormik({
        initialValues: {
            name: "",
            cpf: "",
            email: "",
            phone_number: "",
            address: "",
        },
        validationSchema: Yup.object({
            name: Yup.string().required("Nome obrigatório")
                .max(50, 'O nome deve ter no máximo 50 caracteres')
                .test(
                    "two-words",
                    "O nome deve ser completo, formado por mais de uma palavra.",
                    (value) => value && value.trim().split(/\s+/).length >= 2
                ),
            cpf: Yup.string()
                .required("CPF é um campo obrigatório")
                .length(11, "O CPF deve ter exatamente 11 dígitos")
                .matches(/^\d+$/, "O CPF deve conter apenas números (sem pontos ou traços)")
                .test("valid-cpf", "Este CPF não é válido", validateCPF),
            email: Yup.string().email("Formato de email inválido").required("Email obrigatório"),
            phone_number: Yup.string()
                .matches(/^[0-9]*$/, "O telefone deve conter apenas números (sem espaços ou símbolos)")
                .max(11, "O telefone deve ter no máximo 11 dígitos"),
        }),
        onSubmit: (values) => {
            onSubmit({
                ...values,
                role: "PARENT",
                login_code: sessionStorage.getItem("loginCode"),
                client_code: sessionStorage.getItem("clientCode"),
                user_status: true,
            });
        },
    });

    const handleChange = (e) => {
        onDirty();
        formik.handleChange(e);
    };

    const handleCpfBlur = (e) => {
        const digits = e.target.value.replace(/\D/g, '');
        if (digits.length > 0 && digits.length < 11) {
            formik.setFieldValue('cpf', digits.padStart(11, '0'));
        }
        formik.handleBlur(e);
    };

    return (
        <form
            data-step-form
            onSubmit={formik.handleSubmit}
            className="flex flex-col gap-4"
            onChange={onDirty}
        >
            <label>
                <div className="flex relative items-center justify-between">
                    <p>Nome do Responsável</p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.barcode && formik.errors.barcode ? 'border-red-500' : ''
                        }`}
                    name="name"
                    type="text"
                    onChange={handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                />
                {formik.touched.name && formik.errors.name && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.name}</p>
                )}
            </label>

            <label>
                <div className="flex relative items-center justify-between">
                    <p> CPF </p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.cpf && formik.errors.cpf ? 'border-red-500' : ''
                        }`}
                    name="cpf"
                    type="text"
                    onChange={formik.handleChange}
                    onBlur={handleCpfBlur}
                    value={formik.values.cpf}
                />
                {formik.touched.cpf && formik.errors.cpf && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.cpf}</p>
                )}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    <p>Email</p>
                    <ModalInfo
                        icon={<RiErrorWarningLine />}
                        content="Campo Obrigatório!"
                    />
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.barcode && formik.errors.barcode ? 'border-red-500' : ''
                        }`}
                    name="email"
                    type="text"
                    onChange={handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.email}
                />
                {formik.touched.email && formik.errors.email && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.email}</p>
                )}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    <p>Telefone</p>
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.phone_number && formik.errors.phone_number ? 'border-red-500' : ''
                        }`}
                    name="phone_number"
                    type="text"
                    onChange={handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.phone_number}
                />
                {formik.touched.phone_number && formik.errors.phone_number && (
                    <p className="text-red-500 text-xs font-medium absolute">{formik.errors.phone_number}</p>
                )}
            </label>

            <label>
                <div className="flex items-center justify-between">
                    <p>Endereço</p>
                </div>
                <input
                    className={`block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none ${formik.touched.address && formik.errors.address ? 'border-red-500' : ''
                        }`}
                    name="address"
                    type="text"
                    onChange={handleChange}

                    onBlur={formik.handleBlur}
                    value={formik.values.address}
                />
            </label>
        </form>
    );
};

export default ParentRegisterForm;
